import { createAction, props } from '@ngrx/store';
import { IUser } from '../../user/interfaces/user.interface';

export const setLoggedInUser = createAction(
    '[User] Set Logged In User',
    props<{ user: IUser | null }>(),
);

export const setIsPublishingTenant = createAction(
    '[User] Set Is Publishing Tenant',
    props<{ tenantId: string | null }>(),
);
